module.exports = __webpack_public_path__ + "img/nebezpecna.5f27b563.svg";